import { useApp } from "@/context/AppContext";

// Barra fissa inferiore mobile "Prenota" (non copre i campi dei moduli grazie allo z-index e al padding del body)
export default function MobileBookBar() {
  const { scrollToId } = useApp();
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-brand-white/95 backdrop-blur-md border-t border-brand-ivory p-3 pb-[env(safe-area-inset-bottom)]">
      <button data-testid="mobile-book-bar" onClick={() => scrollToId("booking")} className="w-full bg-brand-olive text-white rounded-full py-3 font-medium">
        Prenota
      </button>
    </div>
  );
}
